export type DateInput = Date | string | number;

export type DateRange = {
  startDate: Date;
  endDate: Date;
};

export enum DateParts {
  YEAR = 'year',
  MONTH = 'month',
  WEEK = 'week',
  DATE = 'date',
}

export enum TimeParts {
  HOUR = 'hour',
  MINUTE = 'minute',
  SECOND = 'second',
}

export enum DatePresetName {
  TODAY = 'TODAY',
  YESTERDAY = 'YESTERDAY',
  PAST_24_HOURS = 'PAST_24_HOURS',
  PAST_3_DAYS = 'PAST_3_DAYS',
  PAST_5_DAYS = 'PAST_5_DAYS',
  WEEK_TO_DATE = 'WEEK_TO_DATE',
  PAST_7_DAYS = 'PAST_7_DAYS',
  PAST_WEEK = 'PAST_WEEK',
  PAST_14_DAYS = 'PAST_14_DAYS',
  MONTH_TO_DATE = 'MONTH_TO_DATE',
  PAST_30_DAYS = 'PAST_30_DAYS',
  PAST_MONTH = 'PAST_MONTH',
  TOMORROW = 'TOMORROW',
  NEXT_24_HOURS = 'NEXT_24_HOURS',
  NEXT_3_DAYS = 'NEXT_3_DAYS',
  NEXT_5_DAYS = 'NEXT_5_DAYS',
  NEXT_7_DAYS = 'NEXT_7_DAYS',
  NEXT_WEEK = 'NEXT_WEEK',
  NEXT_14_DAYS = 'NEXT_14_DAYS',
  NEXT_30_DAYS = 'NEXT_30_DAYS',
  NEXT_MONTH = 'NEXT_MONTH',
}

export type DatePreset = {
  label: string;
  format: () => DateRange;
};
